import type { ReactNode } from 'react'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { AUTH_FORM_TITLE_ID } from '@/scopes/auth/infrastructure/formTitle'
import styles from './AuthFormLayout.module.css'

export interface AuthFormLayoutProps {
  title: string
  subtitle: string
  dataQa: string
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void
  children: ReactNode
}

export function AuthFormLayout({ title, subtitle, dataQa, onSubmit, children }: AuthFormLayoutProps) {
  return (
    <form className={styles.form} data-qa={dataQa} onSubmit={onSubmit} noValidate>
      <div className={styles.header}>
        <Typography as="h1" id={AUTH_FORM_TITLE_ID} tabIndex={-1} className={styles.title}>
          {title}
        </Typography>
        <Typography as="p" variant="body-m-regular-snug">
          {subtitle}
        </Typography>
      </div>
      {children}
    </form>
  )
}
